
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FormGroup extends Vue {
  @Prop({ type: String, default: "" })
  readonly headerText?: string;
}
